const stateName = '[Shared][Folder] ';

export class SharedFolderGetRelatedElementsAction {
    static readonly type = stateName + 'GetRelatedElements';

    constructor(public folderId: number) {
    }
}

export class SharedFolderDeleteFolderAction {
    static readonly type = stateName + 'DeleteFolder';

    constructor(public data: { folderId: number, shouldDeleteRelatedFiles: boolean }) {
    }
}
